<template>
  <div>

    <LazyPartialsCommonHeaderSlideAccount v-model="$uiStore.state.accountSlide" />

    <LazyPartialsCommonHeaderSlideCart v-model="$uiStore.state.cartSlide" />

    <div class="flex justify-between items-center">
      <p class="font-primary text-heading-1 flex items-center space-x-3">
        <NuxtLink href="/">
          <NuxtImg :src="logoSrc" class="mx-auto" format="webp" width="102" height="45" />
        </NuxtLink>
      </p>
      <LazyPartialsCommonSearchInput></LazyPartialsCommonSearchInput>
      <div>
        <div class="flex items-center font-medium">
          <p @click="$uiStore.state.accountSlide = true" class="cursor-pointer font-primary text-heading-4 pr-4">
            HESAP
          </p>
          <div @click="$uiStore.state.cartSlide = true" class="cursor-pointer font-primary text-heading-4 px-4">

            <ClientOnly>
              <div class="relative">
                <p>SEPET <span class="text-orange-500">{{ props.cart.cartQyt }}</span></p>
                <span class="text-xs absolute left-0 -bottom-6 text-orange-500 bg-slate-50 p-1 rounded-md">{{
                  formatPrice(props.cart.cartTotalAmount) }}</span>
              </div>
            </ClientOnly>
          </div>
        </div>
      </div>
    </div>

    <div class="scroll-container my-8 w-full rounded-sm">
      <NuxtLink v-for="cat in props.categories" :key="cat.id"
        class="font-medium px-4 first:pl-0 text-center cursor-pointer inline-block align-top"
        :to="`/${cat.slug}-a${cat.id}`">
        <NuxtImg :src="'cl/' + cat.icon" width="80px"
          class="border-2  object-cover object-top min-w-20 h-20 border-orange-300 rounded-full   hover:p-0 duration-200 mb-2" />
        <span class="block overflow-hidden text-ellipsis">
          {{ cat.name }}
        </span>
      </NuxtLink>
    </div>
    <PartialsCommonHeaderSlideNestedMenu v-model="$uiStore.state.menuSlide" :menu="props.categories"
      :selected-category="selectedCategory" />
  </div>
</template>

<script setup>
const props = defineProps(["categories", "cart"]);
const logoSrc = "cl/cfd082d7-37a8-4067-fafe-f214b571f700/public";
const selectedCategory = ref(null); // selectedCategory ref olarak tanımlandı
</script>
